(function ($) {
   $(function () {
      function updateHeaderHeight() {
         var totalHeight = $('header > .wp-block-group').outerHeight();
         document.documentElement.style.setProperty(
            '--header-height',
            totalHeight + 'px',
         );
      }

      // Initial calculation
      updateHeaderHeight();

      // Recalculate on window resize
      $(window).on('resize', function () {
         updateHeaderHeight();
      });
      // add a class to header when scrolling down

      function checkHeaderScrolled() {
         if ($(window).scrollTop() > 20) {
            $('header').addClass('scrolled');
         } else {
            $('header').removeClass('scrolled');
         }
      }

      // Run on load
      checkHeaderScrolled();

      // Run on scroll
      $(window).on('scroll', checkHeaderScrolled);

      $('.is-style-menu-btn > button').on('click', function () {
         $(this).toggleClass('open');
         $('.open-menu-wrapper').toggleClass('open');
      });
      // close the menu when clicking outside of it
      $(document).on('click', function (event) {
         if (
            !$(event.target).closest('.open-menu-wrapper > div').length &&
            !$(event.target).closest('div:has(> .wp-block-search)').length
         ) {
            $('.open-menu-wrapper').removeClass('open');
            $('.is-style-menu-btn > button').removeClass('open');
         }
      });
   });
})(jQuery);
